import { Map, List, fromJS } from 'immutable'
import createReucer from '@/models/createReucer'
import {
  LIST_FETCHED,
  UPDATED,
  CREATED,
  TOGGLE_LOADING
} from './actionTypes'

const initializeState = Map({
  entries: List(),
  fetching: false,
  total: 0
})

export default createReucer({
  [TOGGLE_LOADING]: (state) => state.update('fetching', fetching => !fetching),

  [LIST_FETCHED]: (state, { payload }) => {
    const { total, data } = payload

    return state
      .set('total', total)
      .set('entries', List(fromJS(data)))
  },

  [UPDATED]: (state, { payload }) =>
    state.update(
      'entries',
      list =>
        list.update(
          (() => {
            return list.findIndex(item => {
              console.log(item)
              return item.get('_id') === payload.id
            })
          })(),
          item => item ? item.merge(payload.data): item
        )
    ),

  [CREATED]: (state, { payload }) =>
    state
      .update('total', total => total+1)
      .update('entries', entries => entries.unshift(new Map(payload))),
}, initializeState)
